import React, {useState , useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import GoalTrackingModal from "../../core/modals/goalTrackingModal";
import { fetchAllGoallist, UpdateGoallistbyemployee } from "../../core/data/redux/performance/goallist/goallistAction";
import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch } from '../../core/data/redux/store';
import DeleteModal1 from "../../core/modals/deleteModal1";
import { DatePicker, message } from "antd";
import moment from "moment"; 
import { Table, Select, InputNumber, Button, Modal } from "antd"; 
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { fetchAllGoallistbyemployeeId } from "../../core/data/redux/performance/goallist/goallistAction";
import {  UpdateGoallist ,deleteGoallist } from "../../core/data/redux/performance/goallist/goallistAction";
import { getEmployeeByUserId } from "../../core/data/redux/employee/employeeAction";
import { formatDate } from "../../core/utils/configFormatters";
import { useAppConfig } from "../../customhooks/useAppConfig";



const GoalTracking = () => {


  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const [employeeId , setemployeeId] = useState<any>()
  const [goalbyemployeeId , setgoalbyemployeeId] = useState<any>()
  const {goaltype} = useSelector((state: any) => state.performance.goaltype)
  const {goallist} = useSelector((state: any) => state.performance.goallist)
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(false);
  const { goal ,loadingStates} = useSelector((state: any) => state.performance.goal);
   const isLoading = isEditing  ? loadingStates.update : loadingStates.create;
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const goallistId = selectedRowData?.id;
  const [updatedStatus, setUpdatedStatus] = useState<string>("");
  const [updatedProgress, setUpdatedProgress] = useState<number>(0);
  const { Option } = Select;


  useEffect(() => {
    if (user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId.toString() }))
        .then(async (res) => {
          setemployeeId(res?.payload?.data?.employeeId);
        });
    }
  }, [user?.UserId, dispatch]); 
  


    useEffect(() => {
      const timeout = setTimeout(() => {
        dispatch(fetchAllGoallistbyemployeeId(employeeId))
        .then((res) =>{
          setgoalbyemployeeId(res.payload.data)
        })
      }, 1000);
    
      return () => clearTimeout(timeout); 
    }, [employeeId]); 
    
  

    const handleEdit = (record: any) => {
      setSelectedRowData(record);
      setUpdatedStatus(record.Status);
      setUpdatedProgress(record.progress);
      setIsEditing(true);
    };
    
    const handleDelete = (id: string) => {
      setIsDeleteModalVisible(true);
    setSelectedRowData({ Id: id });
    };
     
    const handleUpdate = () => {
      if (!updatedStatus || updatedProgress === null || updatedProgress === undefined) {
        alert("Please fill all fields before submitting.");
        return;
      }

      
      if (selectedRowData) {
        const updatedData = {
          ...selectedRowData,
          Status: updatedStatus.charAt(0).toUpperCase() + updatedStatus.slice(1), 
          progress: updatedProgress,
          modifiedBy : user.UserId
        };
      
        dispatch(UpdateGoallistbyemployee({goallistId : goallistId , data : updatedData}))
        .then((res) =>{
            message.success("Progres Updated");
        })
        setIsEditing(false);
      }
      
     setTimeout(() => {
       window.location.reload();
     }, 1000);
    };
    

  const routes = all_routes;
  const data = goalbyemployeeId ? goalbyemployeeId : [];

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Goal",
      dataIndex: "goal_name",
      sorter: (a: any, b: any) => a.goal_name.length - b.goal_name.length,
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      sorter: (a: any, b: any) => a.weightage.length - b.weightage.length,
    },
    {
      title: "Subject",
      dataIndex: "subject",
      sorter: (a: any, b: any) => a.subject.localeCompare(b.subject),
    },
    {
      title: "Target Achievement",
      dataIndex: "achievement",
      sorter: (a: any, b: any) => a.achievement.localeCompare(b.achievement),
    },
    {
      title: "Start Date",
      dataIndex: "StartDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime(),
    },
    {
      title: "End Date",
      dataIndex: "EndDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => new Date(a.EndDate).getTime() - new Date(b.EndDate).getTime(),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: any) => (
        <span className={`badge ${text === "Active" ? "badge-success" : "badge-danger"}`}>
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
    },
    {
      title: "Progress",
      dataIndex: "progress",
      render: (progress: any) => (
        <div>
          <span>{progress}% </span>
          <div className="progress" style={{ width: "100px", height: "5px" }}>
            <div className="progress-bar bg-primary" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.progress - b.progress,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div style={{ display: "flex", gap: "10px" }} className="action-icon d-inline-flex">
          {/* Edit Button */}
          <EditOutlined
            style={{ color: "grey", cursor: "pointer" }}
            onClick={() => handleEdit(record)}
          />
        </div>
      ),
    },
  ];
  

  return (
    <>
      {/* Page Wrapper */}
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Self Goals</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Self Goal
                  </li>
                </ol>
              </nav>
            </div>
            {/* <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal" data-inert={true}
                  data-bs-target="#add_goal"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Goal{" "}
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div> */}
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>My Goals List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
            <Table columns={columns} dataSource={data} rowKey={(record) => record.Id} />;
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
           Developed By{" "} 
            <Link to="#" className="text-primary">
             Leadchain Systems
            </Link>
          </p>
        </div>
      {/* /Page Wrapper */}

     


  <div className={`modal fade ${isEditing ? "show d-block" : ""}`} id="edit_goal_modal">
  <div className={`modal-dialog modal-lg slide-in-from-right`}>
    <div className="modal-content">
      <div className="modal-header bg-primary text-white">
        <h4 className="modal-title">Edit Goal</h4>
        <button type="button" className="btn-close" onClick={() => setIsEditing(false)}></button>
      </div>
      <div className="modal-body">

        
        <div className="border p-2 rounded mb-2">
          <strong>Goal:</strong> {selectedRowData?.goal_name}
        </div>

      
        <div className="border p-2 rounded mb-2">
          <strong>Subject:</strong> {selectedRowData?.subject}
        </div>

       
        <div className="border p-2 rounded mb-2">
          <strong>Target Achievement:</strong> {selectedRowData?.achievement}
        </div>

      
        <div className="border p-2 rounded mb-2">
          <strong>Start Date:</strong> {new Date(selectedRowData?.StartDate).toLocaleDateString()}
        </div>

       
        <div className="border p-2 rounded mb-2">
          <strong>End Date:</strong> {new Date(selectedRowData?.EndDate).toLocaleDateString()}
        </div>

     
        <div className="border p-2 rounded mb-2">
          <label className="form-label">Status<span className="text-danger"> *</span></label>
          <select className="form-select border" value={updatedStatus} onChange={(e) => setUpdatedStatus(e.target.value)}>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* Progress */}
        <div className="border p-2 rounded mb-2">
  <label className="form-label">Progress<span className="text-danger"> *</span></label>
  <div className="d-flex align-items-center">
    <Button
      type="text"
      onClick={() => setUpdatedProgress((prev) => Math.max(0, prev - 5))}
    >
      ↓
    </Button>
    <div style={{ position: "relative", width: "100px", height: "30px" }}>
      <InputNumber
        value={updatedProgress}
        onChange={(value) => setUpdatedProgress(value || 0)}
        min={0}
        max={100}
        className="form-control border"
        style={{ width: "80px" }}
      />
      <div
        style={{
          position: "absolute",
          left: `${updatedProgress}%`,
          top: "-20px",
          transform: "translateX(-50%)",
          background: "blue",
          color: "white",
          padding: "2px 5px",
          borderRadius: "5px",
        }}
      >
        {updatedProgress}%
      </div>
    </div>
    <Button
      type="text"
      onClick={() => setUpdatedProgress((prev) => Math.min(100, prev + 5))}
    >
      ↑
    </Button>
  </div>
</div>

      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-light me-2" onClick={() => setIsEditing(false)}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={handleUpdate} disabled={isLoading}>
          {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
          {isEditing ? " Update Goal" : ""}
          
        </button>
      

      </div>
    </div>
  </div>
</div>

<style>
{`
  .slide-in-from-right {
    position: fixed;
    top: 50px; /* Margin from top */
    right: 0;
    margin: 0;
    height: calc(100% - 50px); /* Full height minus top margin */
    width: 600px;
    transform: translateX(100%);
    transition: transform 0.4s ease-in-out;
    z-index: 1050;
  }

  .modal.show .slide-in-from-right {
    transform: translateX(0);
  }
`}
</style>



      {/* <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedRowData?.Id && handleDeletePolicy(selectedRowData.Id)}
      /> */}

      
    </>
  );
};

export default GoalTracking;
